/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CountyResolutionSource {
  US_CENSUS = 'US_CENSUS',
  GOOGLE_GEOCODER = 'GOOGLE_GEOCODER',
  DB_AUTO = 'DB_AUTO',
  DB_USER = 'DB_USER',
  MANUAL_OVERRIDE = 'MANUAL_OVERRIDE',
}
